module.exports = __webpack_public_path__ + "img/ate-merlyn.89b33f65.jpg";